// extracted by mini-css-extract-plugin
export default {"button":"PrintBlueCardButton__button___FqooX"};